module.exports = __webpack_public_path__ + "media/images/covers/discover-your-future/discover-logo-9-aa3b4a77c6b10068ccddcd63e609e0ec.png";